export default {
  a0: '상위 추천인(Upline) 연결',
  a1: '상위 추천인 주소를 입력하세요',
  a2: '제출',
  a3: 'Binance Smart Chain을 사용해 주세요',
  a4: '유효한 지갑 주소를 입력하세요',
  a5: '온체인 확인 대기 중',
  a6: '연결됨',
  a7: '작업 실패',
  a8: 'NX 유동성',
  a9: '보상 풀',
  b0: '지원 풀',
  b1: '노드 구독',
  b2: '노드 구독 진행 중',
  b3: '구독 완료',
  b4: '지금 참여하기',
  b5: '구독 종료됨',
  b6: '스테이킹',
  b7: '참여 금액',
  b8: '내 잔액',
  b9: '금액을 입력하세요',
  c0: '노드 구독 비용',
  c1: '취소',
  c2: '확인',
  c3: '블록체인 확인 진행 중',
  c4: '스테이킹 성공',
  c5: '스테이킹 완료',
  c6: '스테이킹 기간(일)',
  c7: '스테이킹 금액',
  c8: '일일 수익률',
  c9: '잔액 부족',
  d0: '구독 성공',
  d1: '유효한 참여 금액을 입력하세요',
  d2: '사용 가능한 잔액 부족',
  d3: '참여 기간 아님',
  d4: '가스비 부족',
  d5: '총 주문',
  d6: '총 금액',
  d7: '진행 중',
  d8: '상환 대기',
  d9: '완료됨',
  e0: '스테이킹 금액',
  e1: '수익',
  e2: '스테이킹 상환',
  e3: '데이터 없음',
  e4: '로딩 중',
  e5: '상환됨',
  e6: '홈',
  e7: '스테이킹 내역',
  e8: '내 정보',
  e9: 'NFT 획득 방법 A',
  f0: '총 {num}명의 노드 사용자를 초대하여 NFT를 받으세요',
  f1: '추가로 초대할 노드 사용자 수',
  f2: '',
  f3: 'NFT 획득 방법 B',
  f4: 'V5 등급을 달성하여 NFT 획득',
  f5: '소규모 팀의 실적 차이',
  f6: '내 NFT',
  f7: 'ID',
  f8: '전송',
  f9: 'NFT 전송',
  g0: '전송할 주소를 입력하세요',
  g1: '유효한 전송 주소를 입력하세요',
  g2: '전송 완료',
  g3: '은(는) 글로벌 예측 플랫폼입니다',
  g4: 'NX 거래',
  g5: '아직 이용할 수 없습니다',
  g6: 'CHENXIANG 생태계',
  g7: '팀 보너스 금액',
  g8: '나의 수익',
  g9: '상세 보기',
  h0: '나의 등급',
  h1: '노드 사용자',
  h2: '활성 사용자',
  h3: '다음 등급 달성률',
  h4: '필요 팀 실적',
  h5: '나의 커뮤니티',
  h6: '초대 링크',
  h7: '복사',
  h8: '나의 상위 추천인',
  h9: '개인 실적',
  i0: '팀 실적',
  i1: '복사됨',
  i2: '복사 실패',
  i3: '수익 내역',
  i4: '노드 추천',
  i5: '스테이킹 수익',
  i6: '팀 수익',
  i7: '노드 해제',
  i8: '노드 배당금',
  i9: 'NFT 배당금',
  j0: '60일 스테이킹 보상',
  j1: '더 보기',
  j2: '스테이킹 보상',
  j3: '권한 없음'
}
